<script setup lang="ts">
import { useWallet } from 'solana-wallets-vue';
import { useRouter } from 'vue-router';
import ConnectWalletBtn from '../atoms/ConnectWalletBtn.vue';
import { watch } from 'vue';
import { shortAddress } from '@/helpers/shortAddress';

const { connected, disconnect, publicKey } = useWallet();
const router = useRouter();

const disconnectWallet = () => {
  disconnect();
  router.push({ name: 'Home' });
};

const goToPortfolio = () => {
  router.push({
    name: 'Portfolio',
    params: {
      addresses: publicKey.value?.toBase58(),
      bundleId: undefined,
    },
  });
};

watch(connected, () => {
  if (connected.value) {
    goToPortfolio();
  }
});
</script>

<template>
  <div class="max-sm:hidden">
    <v-btn v-if="connected" variant="tonal" @click="goToPortfolio"
      >{{ shortAddress(publicKey?.toBase58() ?? '') }}

      <v-menu
        activator="parent"
        location="bottom end"
        transition="false"
        :close-on-content-click="false"
      >
        <v-list density="compact">
          <v-list-item
            title="Disconnect"
            @click="disconnectWallet"
          ></v-list-item>
        </v-list> </v-menu
    ></v-btn>
    <ConnectWalletBtn variant="tonal" v-else />
  </div>
  <div class="sm:hidden">
    <v-btn v-if="connected" size="40" variant="tonal" @click="disconnect" icon>
      <v-icon icon="mdi-logout" size="18"></v-icon>
    </v-btn>
    <ConnectWalletBtn variant="tonal" iconMode v-else />
  </div>
</template>
